export default __webpack_public_path__ + "static/banner-finance-perfect-personal-loan-7b89c42d673801d2c2519dbc9317ae02.jpg";